import * as React from 'react';

import WorkSummaryBillingType from 'ab-enums/workSummaryBillingType.enum';

import styles from './styles.module.scss';

const META_FOR_BILLING_TYPE = {
	[WorkSummaryBillingType.BILLABLE_WORK]: {
		letter: 'W',
		colorClassName: styles.billableWork,
	},
	[WorkSummaryBillingType.MATERIAL_COST]: {
		letter: 'M',
		colorClassName: styles.materialCost,
	},
};

interface OwnProps {
	billingType: WorkSummaryBillingType;
	className?: string;
	small?: true;
}

type Props = OwnProps;

const BillingTypeIndicator: React.FC<Props> = (props) => {
	const { billingType, className: externalClassName = '', small } = props;

	const { letter, colorClassName } = META_FOR_BILLING_TYPE[billingType];

	const className = React.useMemo(() => {
		return `${styles.BillingTypeIndicator} ${externalClassName} ${colorClassName} ${small ? styles.small : ''}`;
	}, [colorClassName, externalClassName, small]);

	return (
		<div className={className}>
			{letter}
		</div>
	);
};

export default React.memo(BillingTypeIndicator);
